import React from 'react';

import { View } from 'react-native';

import { useTranslation } from 'react-i18next';

import FullscreenIcon from 'assets/images/svgs/Player/ico_fullscreen.svg';
import MiniPlayerIcon from 'assets/images/svgs/Player/ico_mini_player.svg';

import { LANGUAGE_KEYS } from 'config/languageKeys';

import SvgButton from 'components/CustomButtons/SvgButton';

import styles from './styles';

type Props = {
    onFullscreenPress?(): void;
    onPictureInPicturePress?(): void;
    showOverlay: boolean;
};

const {
    ACCESSIBILITY: {
        PLAYER: { ACCESSIBILITY_PLAYER_MAXIMIZE },
    },
} = LANGUAGE_KEYS;

function TopMinimizedOverlaySection({
    onFullscreenPress,
    onPictureInPicturePress,
    showOverlay,
}: Props) {
    const { t } = useTranslation();

    if (!showOverlay) {
        return null;
    }

    return (
        <View style={styles.root}>
            {onPictureInPicturePress ? (
                <SvgButton
                    Svg={MiniPlayerIcon}
                    onPress={onPictureInPicturePress}
                />
            ) : (
                <View />
            )}
            <SvgButton
                accessible
                accessibilityRole="button"
                accessibilityLabel={t(ACCESSIBILITY_PLAYER_MAXIMIZE)}
                Svg={FullscreenIcon}
                onPress={onFullscreenPress}
            />
        </View>
    );
}

export default TopMinimizedOverlaySection;
